/** @jsxImportSource @emotion/react */
import { Icon, createStyles } from '@quickbit/qb-design-system';

interface Props {
  loading: boolean;
  size?: number;
}

export const Loading = ({ loading, size = 48 }: Props) => {
  const styles = useStyles();

  if (!loading) return null;

  return (
    <div css={styles.root}>
      <Icon name="spinner" size={`${size}px`} />
    </div>
  );
};

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
